export default __webpack_public_path__ + "static/media/landing-page-2.f748b47b.jpg";